import {
	ChangeDetectionStrategy,
	Component,
	HostBinding,
	Input
} from '@angular/core';

@Component({
	selector: 'vb-scrub-bar-current-time-bubble',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `<span>{{ currentTime | vbPlayerTime }}</span>`,
	host: {
		'[class.time-label]': 'true'
	},
	standalone: false,
	styleUrls: ['./VbScrubBarCurrentTimeBubble.Component.ng.less']
})
export class VbScrubBarCurrentTimeBubbleComponent {
	@Input() public currentTime: number; // ms
	@Input() @HostBinding('class.vbScrubBarCurrentTimeBubbleIsLiveHide') public isLive: boolean;
	@Input() @HostBinding('style.left') public scrubBarPercentage: string;
}
